import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import { useDownloadOptions } from './useDownloadOptions';
import { DEMAND, formatCurrency, getValidNumber } from '@demandproai/shared';
import usePlaintiffs from './usePlaintiffs';

export const getMedicalBillData = (medicalBillData = []) => {
    const billMap = new Map();
    for (const bill of medicalBillData) {
        const medicalProviderName = bill?.medicalProviderName.split('_')[0];
        const totalBillAmount = getValidNumber(bill?.totalBillAmount);

        if (billMap.has(medicalProviderName)) {
            billMap.set(medicalProviderName, billMap.get(medicalProviderName) + totalBillAmount);
        } else {
            billMap.set(medicalProviderName, totalBillAmount);
        }
    }

    const billPerProvider = [];
    billMap.forEach((totalBillAmount, medicalProviderName) => {
        billPerProvider.push({ medicalProviderName, totalBillAmount: formatCurrency(totalBillAmount) });
    });

    return billPerProvider;
}

export const useMedicalSummary = () => {
    const {plaintiffs, isCurrentClientHasAnyMedicalRecords} = usePlaintiffs();
    const proccessedMedicalRecordsStored = useSelector(state => state.preProcessMedicalRecords.injuryData);

    const { selectedTiffIndex, setSelectedTiffIndex, openMedicalSummaryModal, hasCompletedMedicalOrDemandRequest } = useAddCaseFormContext();
    const { caseId } = useParams();
    const { downloadDemandDraft } = useDownloadOptions();

    const viewMedicalSummary = (e) => {
        e.preventDefault()
        openMedicalSummaryModal()
    }

    const getMedicalBillDataForClient = useCallback((clientId) => {
        const filterClientsMedicalData = proccessedMedicalRecordsStored?.medicalProcessedData?.find(
            (client) => client.clientId === clientId
        )
        return filterClientsMedicalData;
    }, [proccessedMedicalRecordsStored]);

    const filterClientsMedicalData = useMemo(() =>
        getMedicalBillDataForClient(plaintiffs[selectedTiffIndex]?.clientId),
        [plaintiffs, selectedTiffIndex, getMedicalBillDataForClient]
    );

    const groupedBillData = useMemo(() =>
        getMedicalBillData(filterClientsMedicalData?.medicalBillRecords),
        [filterClientsMedicalData]
    );

    const handleDownload = () => {
        downloadDemandDraft({ caseId, typeOfDemandDraft: DEMAND.Medical_Chronology });
    };

    return {
        viewMedicalSummary,
        selectedTiffIndex,
        setSelectedTiffIndex,
        filterClientsMedicalData,
        groupedBillData,
        handleDownload,
        hasUserUploadedAnyMedicalRecords: isCurrentClientHasAnyMedicalRecords,
        isMedicalRecordsGeneratedPreviously: hasCompletedMedicalOrDemandRequest,
        plaintiffs
    };
};
